<template>
  <!-- modal delete modul -->
  <transition name="fade">
    <div v-if="display" class="opacity-30 fixed inset-0 z-40 bg-black"></div>
  </transition>
  <transition
    name="custom-classes-transition"
    enter-active-class="animated bounceIn"
    leave-active-class="animated bounceOut"
    :duration="{ enter: 500, leave: 500 }"
  >
    <div
      v-if="display"
      class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
    >
      <div class="relative w-3/4 md:w-1/4 my-6 mx-auto">
        <div
          v-click-away="close"
          class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none"
        >
          <div
            class="relative border-t-8 border-red-500 rounded-t-md text-center"
          >
            <div class="w-full text-all-center -mt-8">
              <div
                class="rounded-full bg-red-500 w-14 h-14 items-center justify-center"
              >
                <!-- <i class="fas fa-exclamation fa-2x text-white self-center py-2"></i> -->
                <i class="fas fa-trash-alt fa-2x text-white py-3"></i>
              </div>
            </div>
          </div>
          <div class="relative px-3 py-3">
            <div class="w-full text-center">
              <span class="font-bold">{{ title }}</span>
              <p v-if="note" class="text-xs">{{ note }}</p>
            </div>
          </div>
          <div
            class="flex items-center justify-end rounded-b p-2 bg-gray-200 bg-opacity-50"
          >
            <button
              class="w-1/2 inline-flex justify-center hover:text-white hover:bg-gray-500 border border-red-500 hover:border-gray-500 text-red-500 font-bold uppercase text-sm px-2 py-2 mr-1 rounded outline-none focus:outline-none"
              type="button"
              style="transition: all .15s ease"
              @click="close"
            >
              Cancel
            </button>
            <button
              class="w-1/2 inline-flex justify-center text-white bg-red-500 hover:bg-red-700 font-bold uppercase text-sm px-2 py-2 ml-1 rounded outline-none focus:outline-none"
              type="button"
              style="transition: all .15s ease"
              @click="deleteBtn"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Popup Delete",
  props: {
    display: Boolean,
    title: String,
    note: String,
    close: Function,
    deleteBtn: Function,
  },
};
</script>
